import { useState } from "react";
import CloseIcon from "@rsuite/icons/Close";
import PhoneFillIcon from "@rsuite/icons/PhoneFill";

import "./supportElement.scss";

const SupportElement = (props) => {
  const [expanded, setExpanded] = useState(props.expanded);
  const { supportElements: suppoertItem } = props;

  return (
    <div
      className={`support-element ${
        expanded || props.expanded ? "expanded" : ""
      }`}
    >
      <button className="btn btn-support" onClick={handleExpand}>
        <div className="phone-icon">
          <PhoneFillIcon />
        </div>

        <div className="close-icon">
          <CloseIcon />
        </div>
      </button>

      <div className="support-container">
        <div className="support-items">
          {suppoertItem
            ? suppoertItem.map((item, Index) => {
                return (
                  <div key={Index} className="support-item">
                    <a href={item.link}>
                      <div className="icon">
                        <img src={item.icon} className="" alt="icon" />
                      </div>

                      <span>پشتیبانی {item.title}</span>
                    </a>
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    </div>
  );

  function handleExpand() {
    setExpanded(!expanded);
  }
};

export default SupportElement;
